import ArchiveFilter from './components/ArchiveFilter/ArchiveFilter';
import SwiperSingle from './components/singleSwiper';
import SwiperNearSpots from './components/nearSpotsSwiper';

// スクロールバーの幅をCSSに格納する関数
const updateScrollBarWidth = () => {
  const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth
  document.documentElement.style.setProperty('--scrollbar-width', `${scrollBarWidth}px`)
}
const debounce = (callback) => {
  let timeout;
  return (...args) => {
    if (timeout !== undefined) cancelAnimationFrame(timeout);
    timeout = requestAnimationFrame(() => callback(...args));
  };
};
window.addEventListener('resize', debounce(updateScrollBarWidth));
window.addEventListener('load', updateScrollBarWidth);

// ArchiveFilter
//
// アーカイブ一覧ページにおける絞り込みフォーム要素パーツ
if (document.querySelector('[data-role="archive-filter"]')) {
  if (document.querySelector('.archive-filter-area-map')) {
    // eslint-disable-next-line no-new
    new ArchiveFilter();
  } else {
    // eslint-disable-next-line no-new
    new ArchiveFilter({ disableAreaMapMode: true });
  }
}

// header関連
if (document.querySelector('.global-header') !== null) {
  // ハンバーガーメニュー
  const menuToggleBtn = document.querySelector('.js-menu-toggle');
  if (menuToggleBtn) {
    menuToggleBtn.onclick = function () {
      const isOpen = this.classList.contains('is-menu-open');
      this.classList.toggle('is-menu-open');
      this.setAttribute('aria-expanded', !isOpen);
      document.body.classList.toggle('is-hidden');
    };
  }
  // トグルボタン（アコーディオンなど）
  document.querySelectorAll('[data-role="toggle-btn"]').forEach((btn) => {
    btn.onclick = function () {
      this.classList.toggle('is-open');
    };
  });
}
if (document.querySelector('.business-header') !== null) {
  // menu開閉ボタン
  const menuBtn = document.querySelector('.js-menu-toggle');
  if (menuBtn) {
    menuBtn.addEventListener('click', function () {
      const expanded = this.classList.contains('is-menu-open');
      if (expanded) {
        this.classList.remove('is-menu-open');
        this.setAttribute('aria-expanded', 'false');
        this.setAttribute('aria-label', 'メニュー');
      } else {
        this.classList.add('is-menu-open');
        this.setAttribute('aria-expanded', 'true');
        this.setAttribute('aria-label', '閉じる');
      }
    });
  }
}

// tab
const cmnTabElms = document.querySelectorAll('[data-role="cmn-tab"]');
if (cmnTabElms.length) {
  cmnTabElms.forEach((elm) => {
    const tabBtnsArea = elm.querySelector('[role="tablist"]');
    tabBtnsArea.addEventListener('click', (ev) => {
      const tabBtnElm = ev.target;
      if (tabBtnElm.hasAttribute('data-target')) {
        let tabTarget;
        let tabCurrentTarget = tabBtnElm.getAttribute('data-target');

        // ボタン切り替え
        const tabBtns = elm.querySelectorAll('[data-role="tabbtn"]');
        tabBtns.forEach((tabBtn) => {
          tabTarget = tabBtn.getAttribute('data-target');
          if (tabTarget === tabCurrentTarget) {
            tabBtn.classList.add('is-active');
            tabBtn.ariaSelected = true;
            tabBtn.removeAttribute('tabindex');
          } else {
            tabBtn.classList.remove('is-active');
            tabBtn.ariaSelected = false;
            tabBtn.setAttribute('tabindex', '-1');
          }
        });

        // パネル切り替え
        const tabContentsElm = elm.querySelectorAll('[role="tabpanel"]');
        tabContentsElm.forEach((tabContents) => {
          tabTarget = tabContents.getAttribute('id');
          if (tabTarget === tabCurrentTarget) {
            tabContents.classList.add('is-active');
          } else {
            tabContents.classList.remove('is-active');
          }
        });
      }
    });
  });
}

// 近くのスポット用swiper
const singleSwiperElms = document.querySelectorAll("[data-role='single-swiper']");
if (singleSwiperElms.length) {
  singleSwiperElms.forEach((elm) => {
    // eslint-disable-next-line no-new
    new SwiperSingle({ elm });
  });
}

// 近くのスポット用swiper
const nearSpotsSwiperElms = document.querySelectorAll("[data-role='near-spots-swiper']");
if (nearSpotsSwiperElms.length) {
  nearSpotsSwiperElms.forEach((elm) => {
    // eslint-disable-next-line no-new
    new SwiperNearSpots({ elm });
  });
}

// 規約同意ボタンをチェックすると送信ボタンが有効になる
const agreeCheckbox = document.querySelector('.js-agree-check');
if (agreeCheckbox !== null) {
  const submitBtn = document.querySelector('.js-submit-disable');
  agreeCheckbox.addEventListener('click', () => {
    if (agreeCheckbox.checked === true) {
      submitBtn.disabled = false;
      submitBtn.classList.remove('is-disabled');
    } else {
      submitBtn.disabled = true;
      submitBtn.classList.add('is-disabled');
    }
  });
}
